import React, { Suspense, useState } from "react";
import "./App.css";
import { NavBar } from "./components";
import { Outlet } from "react-router-dom";
import FadeIn from "./components/fade-in";
import ContactModal from "./components/contact-modal";
import Footer from "./components/footer";
import ChatWidget from "./components/portfolio-chat/chat-widget";
import { RouteLoader } from "./components/loading-page";

const App = () => {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <main>
      <FadeIn key="App-Main-Page">
        <NavBar onOpenContact={() => setContactOpen(true)} />
        <section id="router-body" className="d-flex flex-column w-100">
          <Suspense fallback={<RouteLoader />}>
            <Outlet />
          </Suspense>
        </section>
        <Footer onOpenContact={() => setContactOpen(true)} />
        <ChatWidget />
      </FadeIn>
      {contactOpen ? (
        <ContactModal onClose={() => setContactOpen(false)} />
      ) : null}
    </main>
  );
};

export default App;
